<template>
  <div>
    <!-- 添加/编辑-大分类： -->
    <el-dialog :title="isAdd ? $t('message.addCategory') : $t('message.editCategory')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1380px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 排序 -->
          <el-form-item :label="$t('message.sort')" prop="sort">
            <el-input v-model="ruleForm.sort" style="width: 100px;"></el-input>
            <span style="color: #c35257;">*数字越大越靠前</span>
          </el-form-item>
          <!-- 状态 -->
          <el-form-item :label="$t('message.status')">
            <el-switch v-model="ruleForm.status_type">
            </el-switch>
          </el-form-item>
          <!-- 分类名称 -->
          <el-form-item :label="$t('message.classificationyName')" prop="name">
            <el-input v-model="ruleForm.name" type="textarea"></el-input>
          </el-form-item>
          <!-- 分类说明 -->
          <el-form-item :label="$t('message.categoryDescription')">
            <quill-editor ref="myTextEditor" id="quill-editor" v-model="ruleForm.desc" :options="quillOption">
            </quill-editor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="optionDescCategoryStore" v-if="isAdd">{{
          $t("message.ok")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="optionDescCategoryUpdate" v-else>{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    quillEditor
  },
  props: {
    isAdd: { type: Boolean }
  },
  data() {
    return {
      quillOption: quillConfig,
      ruleForm: {
      },
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ]
      },
    };
  },
  methods: {
    // 新增
    optionDescCategoryStore() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.status = this.ruleForm.status_type ? 1 : 0
          this.$api.siteConfiguration.optionDescCategoryStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.optionDescList()
          });
        }
      })
    },
    // 修改
    optionDescCategoryUpdate() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.status = this.ruleForm.status_type ? 1 : 0
          this.$api.siteConfiguration.optionDescCategoryUpdate(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.dialogVisible = false;
            this.$parent.optionDescList()
          });
        }
      })
    },
    acceptData(data) {
      this.ruleForm = data
      this.dialogVisible = true
    }
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
}

/deep/.ql-editor {
  min-height: 300px !important;
}
</style>